import { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface PageLayoutProps {
  children: React.ReactNode;
  transparentNav?: boolean;
}

export default function PageLayout({ children, transparentNav = false }: PageLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar transparent={transparentNav} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}